
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke-width":"4","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M29.658 32.997V31.81a4.776 4.776 0 00-2.406-4.146l-4.753-2.727M14.53 24.937l-4.754 2.727a4.778 4.778 0 00-2.407 4.147v1.186","stroke":"#FFF","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18.514 26.651h0c-3.518 0-6.369-3.647-6.369-7.165v-3.184a6.369 6.369 0 016.369-6.368h0a6.369 6.369 0 016.368 6.368v3.184c0 3.518-2.851 7.165-6.368 7.165z","stroke":"#FFF","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M18.514 1.973C8.84 1.973 1 9.814 1 19.486 1 29.16 8.841 37 18.514 37c9.672 0 17.513-7.841 17.513-17.514","stroke":"#FFF","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{staticClass:"fill",attrs:{"d":"M33.842 8.027h-2.464v2.464a.702.702 0 11-1.405 0V8.027h-2.464a.703.703 0 110-1.405h2.464V4.158a.702.702 0 111.405 0v2.464h2.464a.702.702 0 110 1.405M30.676 1a6.324 6.324 0 100 12.649 6.324 6.324 0 000-12.649","fill":"#FFF"}})])])
          )
        }
      }
    